export class CartCount extends HTMLElement {
	constructor() {
		super();
		this.count = this.querySelector('[data-ref="count"]');
	}
	connectedCallback() {
		document.addEventListener('cart:updated', this.updateCount.bind(this));
	}

	updateCount(event) {
		const total = event.detail.totalCount;
		if (this.count) {
			this.count.innerHTML = `${total}`;
		}
	}

	disconnectedCallback() {
		document.removeEventListener('cart:updated', this.updateCount);
	}
}
